<template>
  <div class="info-item">

    <YorkbbsImage class="info-cover" animation fit="cover" target="_blank" :src="coverImage | webpFormat(200)"
      :link="detailURL" v-if="coverImage"></YorkbbsImage>

    <div class="info-item__right">
      <div class="info-main__wrapper">
        <div class="info-main__left">
          <!-- 标题 -->
          <h2>
            <a class="info-title__wrapper" target="_blank" :href="detailURL">
              <img class="info-label__optimized" :src="require('@/assets/images/info/optimized.png')" alt="优选"
                v-if="isOptimized" />
              <span class="info-shop" v-html="shopName"></span>
              <span class="info-title" v-html="title"></span>
              <img class="info-label__vip" :src="require('@/assets/images/info/vip.png')" alt="VIP" v-if="isVip" />
            </a>
          </h2>
          <!-- 板块列表 美食类显示 -->
          <ul class="info-topic__list" v-if="isFoodTopic && topics.length">
            <li class="info-topic__item" v-for="(item, i) in topics" :key="i">{{ item.name }}</li>
          </ul>


          <!-- 地址 -->
          <div class="info-address" v-if="address">{{ address }}</div>

          <div class="info-status-tags">

            <!-- 标签列表 -->
            <ul class="info-tag__list">
              <li class="info-tag__item" v-for="(item, i) in tags" :key="i">{{ item.name }}</li>
            </ul>
          </div>
        </div>
        <div class="info-main__right">
          <!-- 排名 -->
          <div class="info-rank">{{ index + 1 }}</div>

          <!-- 联系电话 -->
          <a class="info-title__wrapper" target="_blank" :href="detailURL">
            <el-button class="button-tel" type="primary">
              <i class="yk-info_phone"></i>
              <span>{{ contactNumber | phoneFormat }}</span>
            </el-button></a>

        </div>
      </div>
      <!-- 图集列表 -->
      <div class="info-image__list" v-if="isOptimized && listImage.length">
        <YorkbbsImage class="info-image__item" v-for="(item, i) in listImage.slice(0, 5)" :key="i" :src="item"
          animation></YorkbbsImage>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RestaurantItem',
  props: {
    data: {
      type: Object,
    },
    // 索引
    index: Number,
    // 是否显示排名
    indexVisible: Boolean,
  },
  data() {
    return {
      telVisible: false,
    };
  },
  computed: {
    // 是否是美食版块
    isFoodTopic() {
      return this.data.property.postTypeId === 2;
    },
    // 是否常用电话
    isChinesePhone() {
      return this.data.property.topics[0].parent.englishName === "chinesephone";
    },
    // 商家中文名
    shopCnName() {

      if (this.data.property.shopCnName) {
        return this.data.property.shopCnName;
      } else if (!this.data.property.shopCnName && !this.data.property.shopEnName) {
        return this.data.title;
      } else {
        return '';
      }

    },
    // 商家英文名
    shopEnName() {
      return this.data.property.shopEnName ? this.data.property.shopEnName : '';
    },
    // 商家名称
    shopName() {

      if ( this.shopCnName && this.shopEnName ) {
        return this.data.property.shopCnName + ' ' + '( ' + this.shopEnName + ' ) ';
      } else if (this.shopCnName && !this.shopEnName) {
        return this.shopCnName+' ';
      } else if (!this.shopCnName && this.shopEnName) {
        return this.shopEnName+' ';
      } else {
        return '';
      }
    },
    // 信息标题
    title() {
      var result = '';
      /* if( this.data.property.shopCnName && this.data.property.shopEnName ){
        result += `${this.data.property.shopCnName}(${this.data.property.shopEnName}) `
      }else if( this.data.property.shopCnName ){
        result += this.data.property.shopCnName + ' ';
      }else if( this.data.property.shopEnName ){
        result += this.data.property.shopEnName + ' ';
      } */
      if( this.data.title != this.data.property.shopCnName ){
        result = this.data.title;
      }
      return result;
    },
    // 信息ID
    id() {
      return this.data.id;
    },
    // 商家英文短名
    merchantId() {
      return this.data.property.merchantId || this.data.id;
    },

    // 是否是优选信息
    isOptimized() {
      return this.data.property.optimized === 1;
    },
    // 是否是VIP
    isVip() {
      // 时长付费或竞价付费的都是VIP
      return this.data.property.payType === 1 || this.data.property.payType === 2;
    },

    // 封面图
    coverImage() {
      return this.data.property.logo || this.data.property.coverImage;
    },
    // 联系人
    contactName() {
      return this.data.property.contactName;
    },
    // 联系电话
    contactNumber() {
      return (this.data.property.contactNumber || '').replace(/\D/g, '');
    },
    // 联系电话
    _contactNumber() {
      return this.contactNumber.slice(0, 3) + '-***-' + this.contactNumber.slice(-4);
    },
    // 地址
    address() {
      return this.data.property.address;
    },
    cityName() {
      return this.data.property.cityName;
    },
    postcode() {
      return this.data.property.postcode;
    },
    _address() {
      return [this.address, this.cityName, this.postcode].filter(item => !!item).join(', ');
    },
    // 标签
    tags() {
      return (this.data.property.tags || []).slice(0, 5);
    },
    // 版块
    topics() {
      return this.data.property.topics || [];
    },
    // 图片集
    listImage() {
      return this.data.property.listImage || [];
    },
    // 排名
    rank() {
      return this.data.property.rank;
    },
    // 详情页地址
    detailURL() {
      return `/restaurant/${this.topics[0].englishName}/${this.merchantId}`;
    },
    // 付费类型
    payType() {
      return this.data.property.payType;
    },
    // 营业标识 0 正常 1 暂时关闭 2 永久关闭
    businessFlag() {
      return this.data.property.businessFlag;
    },
    // 营业状态 0 休息中；1 营业中；每分钟系统自动计算
    businessStatus() {
      return this.data.property.businessStatus;
    },
  },
};
</script>
<style lang="scss" scoped>
.info-item {
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 1px solid #eee;

  &:hover {
    background-color: #f8f8f8;
  }
}

.info-cover {
  width: 160px;
  height: 120px;
  border-radius: 4px;
  border: 1px solid #eee;
  margin-right: 20px;
}

.info-item__right {
  flex: 1;
}

.info-main__wrapper {
  display: flex;
  justify-content: space-between;
}

.info-main__left {
  flex: 1;
  padding-right: 20px;
}

.info-main__right {
  width: 180px;
  position: relative;
  display: flex;
  align-items: center;

  .el-button {
    width: 100%;
  }
}

.info-title__wrapper {
  display: block;
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 10px;
  font-weight: normal;

  &:hover {
    color: var(--primary-color);
  }

}

.info-label__optimized {
  width: 30px;
  vertical-align: middle;
  margin-right: 5px;
}

.info-label__vip {
  width: 18px;
  vertical-align: middle;
  margin-left: 5px;
}

.info-label__unauth {
  display: inline-block;
  font-size: 12px;
  line-height: 22px;
  padding: 0 7px;
  color: var(--text-color-6);
  background-color: #f8f8f8;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 5px;
}

.info-shop {
  font-size: 18px;
  font-weight: 600;
  vertical-align: middle;
}

.info-divider {
  display: inline-block;
  height: 12px;
  border-left: 1px solid var(--text-color-9);
  margin: 0 10px;
  vertical-align: middle;
}

.info-title {
  padding-left: 10px;
  font-size: 16px;
  vertical-align: middle;


}

.info-topic__list {
  display: flex;
  flex-wrap: wrap;
}

.info-topic__item {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-right: 15px;
  margin-bottom: 10px;
}

.info-username {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-bottom: 10px;
}

.info-address {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-bottom: 12px;
}

.info-status-tags {
  display: flex;
}

.info-status__close {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--primary-color);
  margin-right: 12px;
  margin-bottom: 12px;
}

.info-tag__list {
  display: flex;
  flex-wrap: wrap;
}

.info-tag__item {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  margin-right: 15px;
  margin-bottom: 12px;
}

.info-image__list {
  display: flex;
  margin-top: 20px;
}

.info-image__item {
  width: 120px;
  height: 75px;
  border-radius: 4px;

  &:not(:first-child) {
    margin-left: 10px;
  }
}

.button-tel {
  font-size: 18px;
  margin-top: 55px;
  font-weight: 500;

  i {
    font-size: 16px;
    font-weight: inherit;
    margin-right: 7px;
  }
}

.info-rank {
  width: 30px;
  height: 35px;
  background-color: #f8f8f8;
  border-radius: 15px;
  font-size: 20px;
  color: #b9b9b9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: -4px;
  z-index: 1;
}

.info-tel {
  background-color: transparent;
  border: 0 none;
  color: #111;
  font-size: 18px;
  font-weight: 500;

  i {
    font-size: 16px;
    margin-right: 7px;
  }
}

.button-view {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-9);
  margin-left: 43px;
}
</style>
